import { useMemo } from "react";

import type { IStoreFilterableOption } from "@/services/store/select-options";
import { useGetStoresFilterableOptionsQuery } from "@/services/store/select-options";

import { ALL_STORES_CODE } from "../components/edit-campaign/constants";

const DECIMAL_RADIX = 10;

export const useAllStoreCodes = (): number[] => {
  const { data } = useGetStoresFilterableOptionsQuery();

  return useMemo(
    (): number[] =>
      (data ?? [])
        .map((store: IStoreFilterableOption) => Number.parseInt(store.value, DECIMAL_RADIX))
        .filter((code: number) => Number.isInteger(code) && code !== ALL_STORES_CODE),
    [data],
  );
};
